import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

interface Props {
  keywords: string[];
  onChange: (keywords: string[]) => void;
}

const KeywordInput: React.FC<Props> = ({ keywords, onChange }) => {
  const handleChange = (index: number, value: string) => {
    // 20文字制限
    const trimmed = value.slice(0, 20);
    const next = [...keywords];
    next[index] = trimmed;
    onChange(next);
  };

  // 常に5つのフィールドを表示
  const fields = Array.from({ length: 5 }, (_, i) => keywords[i] || '');

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        あなたを表すキーワード
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
        自分を一言で表すキーワードを入力してください（最大5語・各20文字以内）
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {fields.map((value, index) => (
          <TextField
            key={index}
            label={`キーワード ${index + 1}${index >= 3 ? '（任意）' : ''}`}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            size="small"
            fullWidth
            inputProps={{ maxLength: 20 }}
            helperText={value ? `${value.length}/20文字` : ''}
          />
        ))}
      </Box>
    </Box>
  );
};

export default KeywordInput;
